module.exports = __webpack_public_path__ + "static/img/h8.05f3533.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h8.jpg
// module id = vAc7
// module chunks = 0